import { tv } from 'tailwind-variants'

export const typebarStyles = tv({
  slots: {
    wrapper: 'p-4 bg-gray-200 lg:rounded-b-xl',
    canNotSendWrapper: 'h-16 bg-gray-200 lg:rounded-b-xl',
    textArea:
      'flex-1 resize-none rounded-lg overflow-y-auto px-3 py-2 border-none outline-none max-h-28 min-h-9 h-9 text-gray-800 text-sm font-normal leading-normal',
    hiddenInput: 'hidden'
  }
})
